// ============================================
// 静态数据源适配器
// 用于测试和固定数据
// ============================================

import type { DatasourceAdapter } from '../../types/databinding';
import type { DatasourceConfig, StaticConfig } from '../../types/designer';
import { EventEmitter } from '../EventEmitter';

export class StaticAdapter extends EventEmitter implements DatasourceAdapter {
  readonly type = 'static' as const;
  private status: 'disconnected' | 'connecting' | 'connected' | 'error' = 'disconnected';
  private data: any = null;
  private subscriptions: Map<string, Set<(data: any) => void>> = new Map();

  async connect(config: DatasourceConfig): Promise<void> {
    if (config.type !== 'static') throw new Error('Invalid config type');
    this.data = (config.config as StaticConfig).data;
    this.status = 'connected';
    this.emit('status:change', this.status);

    // 连接时自动推送初始数据
    if (this.data !== null) {
      console.log('[StaticAdapter] connect: emitting initial data', this.data);
      this.emit('message', this.data);
    }
  }

  disconnect(): void {
    this.data = null;
    this.subscriptions.clear();
    this.status = 'disconnected';
    this.emit('status:change', this.status);
  }

  subscribe(topic: string, callback: (data: any) => void): void {
    if (!this.subscriptions.has(topic)) {
      this.subscriptions.set(topic, new Set());
    }
    this.subscriptions.get(topic)!.add(callback);

    // 立即发送当前数据
    if (this.data !== null) {
      callback(this.data);
    }
    this.emit('subscribe', { topic });
  }

  unsubscribe(topic: string): void {
    this.subscriptions.delete(topic);
    this.emit('unsubscribe', { topic });
  }

  /**
   * 更新静态数据并通知订阅者
   */
  updateData(data: any): void {
    this.data = data;
    this.subscriptions.forEach((callbacks) => {
      callbacks.forEach((cb) => cb(data));
    });
    this.emit('data:update', data);
  }

  getStatus() {
    return this.status;
  }
}
